import { useQuery } from 'react-query';
import api from 'api';

export const useLoanData = (
  status?: number | number[],
  options?: { enabled?: boolean; staleTime?: number; created_from?: string; created_to?: string },
) => {
  const { enabled, staleTime, created_from, created_to } = options ?? {};
  const statuses = Array.isArray(status) ? status : status != null ? [status] : [];
  const statusKey = statuses.join(',') || 'all';

  return useQuery({
    queryKey: ['LOANS', statusKey, created_from, created_to],
    queryFn: () =>
      api.loans.fetchLoanData({
        ...(statuses.length === 1
          ? { status: statuses[0] }
          : statuses.length > 1
          ? { statuses }
          : {}),
        ...(created_from ? { created_from } : {}),
        ...(created_to ? { created_to } : {}),
      }),
    staleTime: staleTime ?? 0,
    enabled: enabled ?? true,
  });
};
